import React from "react";
import { useNavigate } from "react-router-dom";
import { AiOutlineArrowLeft } from "react-icons/ai"; // import the icon
import classes from "./styles.module.scss";

const PageHeading = ({ head, showBack = false }) => {
    const navigate = useNavigate();

    const handleBack = () => {
        navigate(-1);
    };

    return (
        <div className={classes.pageHeadingContainer}>
            {showBack && (
                <button className={classes.backButton} onClick={handleBack}>
                    <AiOutlineArrowLeft size={20} />
                </button>
            )}
            <p className={classes.heading}>{head}</p>
        </div>
    );
};

export default PageHeading;

